import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../lib/const';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BasicInput from '../elements/BasicInput';
import ConfirmationModal from '../components/ConfirmationModal';
const EnrollmentSummaryPendencies = ({
  pendency,
  reloadPendencies,
  enrollmentId
}) => {
  const [changedPendencyData, setChangedPendencyData] = useState('');
  const [editPendency, setEditPendency] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const changePendency = () => {
    if (editPendency) {
      setEditPendency(false);
      if (changedPendencyData == '') {
        return toast.error('A descrição não pode ser vazia', {
          position: toast.POSITION.TOP_RIGHT
        });
      }
      axios
        .patch(`${API_URL}/onboarding/pendencies/${pendency.id}`, {
          description: changedPendencyData
        })
        .then(response => {
          reloadPendencies(enrollmentId);
        })
        .catch(error => {
          toast.error('Ocorreu um erro inesperado', {
            position: toast.POSITION.TOP_RIGHT
          });
        });
    } else {
      setEditPendency(pendency.id);
    }
  };
  const deletePendency = id => {
    axios
      .delete(`${API_URL}/onboarding/pendencies/${id}`)
      .then(response => {
        reloadPendencies(enrollmentId);
      })
      .catch(error => {
        toast.error('Ocorreu um erro inesperado', {
          position: toast.POSITION.BOTTOM_RIGHT
        });
      });
  };
  if (pendency.resolved_at && editPendency !== pendency.id) {
    return (
      <>
        <div className="pendencies-header">
          {pendency.resolved_at && (
            <FontAwesomeIcon icon="check-circle" className="green mt-1 mr-2" />
          )}
          <div className="mb-2">
            <label className="pendencies-header-title">
              Pendência {pendency.id}:
            </label>
            <small className="d-block ">
              <em>{pendency.step}</em>
            </small>
          </div>
        </div>
        <div className="pendencies-body">{pendency.description}</div>
        <strong>
          <pre>{pendency.justification}</pre>
        </strong>
      </>
    );
  } else {
    return (
      <>
        <div className="pendencies-header">
          <div className="w-100 mb-2 d-flex align-center justify-content-between">
            <div>
              <label className="pendencies-header-title">
                Pendência {pendency.id}:
              </label>
              <small className="d-block ">
                <em>{pendency.step}</em>
              </small>
            </div>
            <div className="w-30 d-flex flex-row">
              <FontAwesomeIcon
                id={`pendencia-${pendency.id}`}
                onClick={() => changePendency()}
                icon={editPendency ? 'check' : 'edit'}
                style={{
                  cursor: 'pointer',
                  fontSize: '17px',
                  color: '#499d96'
                }}
                className="black ml-2"
              />
              <FontAwesomeIcon
                icon="trash"
                onClick={() => setOpenModal(true)}
                style={{
                  cursor: 'pointer',
                  fontSize: '17px',
                  color: '#D24343FF'
                }}
                className="black ml-2"
              />
            </div>
            <ConfirmationModal
              visible={openModal}
              onCancel={() => openModal}
              onConfirm={() => deletePendency(pendency.id)}
              title="Tem certeza que deseja realizar esta ação?"
              confirmText="Sim"
              cancelText="Não"
              children={
                <p>
                  Ao apagar esta penência, ela não poderá ser recuperada, tem
                  certeza que deseja continuar?
                </p>
              }
            />
          </div>
        </div>
        <div className="pendencies-body">
          {pendency.description}
          {editPendency && (
            <BasicInput
              handleChange={e => setChangedPendencyData(e.current.value)}
              label="Descrição:"
            />
          )}
        </div>
        <strong>
          <pre>{pendency.justification}</pre>
        </strong>
      </>
    );
  }
};
export default EnrollmentSummaryPendencies;
